import { fetchResource, useCreatePayload, createCacheKey } from 'hammock';
import { useQuery } from 'react-query';
import { ENDPOINTS } from 'site-constants';

import { useAuthentication } from 'commons/hooks';

// get the organization plan for the redux store.
export const useOrganizationPlan = () => {
  const { organizationPlanId } = useAuthentication();
  const { getAll } = useCreatePayload(ENDPOINTS.organizationPlans);

  const payload = getAll({
    query: {
      finder: 'me',
    },
  });
  const cacheKey = createCacheKey(payload);

  const { data } = useQuery(cacheKey, () => fetchResource(payload));

  if (data) {
    return data.find((plan) => plan.id === organizationPlanId);
  }
  return null;
};

export const useEditorSeatsLimit = () => {
  const { editorSeatsLimit } = useOrganizationPlan() || {};
  return editorSeatsLimit;
};
